import { render, staticRenderFns } from "./VocabCountdownConfigForm.vue?vue&type=template&id=088736b4&scoped=true&"
import script from "./VocabCountdownConfigForm.vue?vue&type=script&lang=js&"
export * from "./VocabCountdownConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./VocabCountdownConfigForm.vue?vue&type=style&index=0&id=088736b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088736b4",
  null
  
)

export default component.exports